/**
 * Utility module for Loop Returns OnStore
 *
 * Documentation:
 *  - https://help.loopreturns.com/en/articles/1917761#set_up_shop_now_on_store
 *
 */

/**
 * Loop Returns UTM redirect query param
 */
const LOOP_UTM_REDIRECT_QUERY_PARAM = 'utm_redirect=Loop_Returns';

/**
 * Check if Loop Returns OnStore is enabled
 *
 * @returns {boolean}
 */
const isEnabled = () => window?.ALLBIRDS?.settings?.loopReturnsOnstore?.enabled || false;

/**
 * Check if Loop Returns OnStore is active
 *
 * @returns {boolean}
 */
const isActive = () => isEnabled() && window?.LoopOnstore?.isActive();

/**
 * Check if Loop Returns OnStore is active via UTM redirect
 *
 * @returns {boolean}
 */
const isUtmRedirectSet = () => {
  const standarizedQueryParams = window.location.search?.toLowerCase() || '';

  return standarizedQueryParams.includes(LOOP_UTM_REDIRECT_QUERY_PARAM.toLowerCase());
};
export { isActive, isEnabled, isUtmRedirectSet };
